const replaceThreshold = (text, tiers) => {
    return text.replace(/{{tier(\d+)}}/g, (_, tierIndex) => {
        const idx = parseInt(tierIndex, 10) - 1;

        // If `idx` is within bounds and `idx + 1` exists, return formatted range
        if (idx < tiers.length - 1 && tiers[idx] && tiers[idx + 1]) {
            return `${tiers[idx].value}-${tiers[idx].maxValue}`;
        }
        
        // If only `tiers[idx]` exists, return formatted value with "+"
        if (tiers[idx]) {
            return `${tiers[idx].value} +`;
        }
        
        // If index is out of bounds, return the placeholder as-is
        return `{{tier${tierIndex}}}`;
    });
};

export default replaceThreshold;
